var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-bar'),_c('div',{staticClass:"row"},[_c('side-bar',{staticClass:"side-bar"}),_c('div',{staticClass:"content"},[_c('router-view'),_c('fhs-footer',{staticClass:"footer"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }